export const restaurant = {
  name: "The Greek Yum Yum's",
  tagline: "Traditional Greek Taverna",
  location: "Tsilivi, Planos 291 00, Zakynthos",
  hoursLine: "Open daily · 11:00 – 00:30",
  yearsOpen: 15,
  owner: "Lorenc Lamaj",
  phone: "+30 697 683 5281",
  phoneRaw: "+306976835281",
  whatsappRaw: "306976835281",
  email: "lorenclamaj1234@gmail.com",
};

export const images = {
  hero:
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/erbr5x68_DSC00268.JPG",
  story:
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/ecaa7n9d_DSC00242.JPG",
  gallery: [
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/g46sypb6_DSC00230.JPG",
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/jpbuciph_DSC00235.JPG",
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/ecaa7n9d_DSC00242.JPG",
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/erbr5x68_DSC00268.JPG",
    "https://customer-assets.emergentagent.com/job_zorba-kitchen/artifacts/g46sypb6_DSC00230.JPG",
  ],
};

// Curated highlights shown on the gallery / hero area
export const signatures = [
  "Lamb Kleftiko",
  "Souvlaki",
  "Gyros Plate",
  "Moussaka",
  "Pastitsio",
  "Beef Stifado",
  "Greek Salad",
];

// Full menu, grouped by section. Pulled from the printed timokatalogos.
export const menu = [
  {
    name: "Daily Specials",
    blurb:
      "A different chef's recommendation every day of the week, alongside two house favourites.",
    items: [
      { name: "Monday · Mix Souvlaki", description: "Chicken, pork & lamb kebab with chips, salad, tzatziki & pita." },
      { name: "Spaghetti with Meatballs", description: "Meatballs in a rich tomato sauce." },
      { name: "Lamb Zante", description: "Slow-roasted lamb with bacon, fresh mushrooms, vegetables, roasted potatoes, garlic & gravy." },
      { name: "Tuesday · Zakynthian Fish", description: "Fish fillet, roasted potatoes, onion, capers, anchovies, tomato sauce." },
      { name: "Beef Yum…Yum…", description: "Tender casseroled beef with roasted potatoes, mushrooms, onion, cream, tomato, feta & gouda." },
      { name: "Pennes Chicken & Shrimps", description: "Chicken, shrimps, creamy sauce, tomato, vodka & parmesan." },
      { name: "Wednesday · Lamb Kleftiko", description: "Slow-roasted lamb with potatoes, peppers, mushrooms, gravy, parmesan & feta." },
      { name: "Pork Chop", description: "With bacon & mushrooms in wine sauce." },
      { name: "Fillet Chicken with Halloumi", description: "Oven-baked chicken fillet with halloumi, cherry tomatoes & estragon tomato sauce." },
      { name: "Thursday · Lamb Yum…Yum…", description: "Slow-roasted lamb with mushrooms, tomato, parmesan & feta baked in a ceramic pot with potatoes & salad." },
      { name: "Stifado", description: "Baby onions in tomato sauce — choice of lamb or beef." },
      { name: "Pastitsio", description: "" },
      { name: "Friday · Fish to the Oven", description: "Fish fillet, mussels, shrimps, potatoes, cherry tomatoes, mushrooms, anchovies, chilli, onions & lemon sauce." },
      { name: "Meatballs Yum…Yum…", description: "Medium meatballs with mushrooms in tomato sauce, parmesan & feta, baked in a ceramic pot." },
      { name: "Chicken Hot Pot", description: "Onion, bacon, mushrooms, wine, creamy sauce, parmesan & melted cheese in a ceramic pot." },
      { name: "Saturday · Moussaka", description: "Daily cooked." },
      { name: "Lamb Chops", description: "" },
      { name: "Chicken Souvlaki", description: "Served with chips, salad, tzatziki & pita." },
      { name: "Sunday · Lamb Shanks", description: "Slow-roasted shanks with roasted potatoes, fresh vegetables & gravy." },
      { name: "Sea Bream", description: "" },
      { name: "Chicken Ala Crème", description: "Fresh mushrooms in a creamy sauce." },
    ],
  },
  {
    name: "Starters & Meze",
    blurb: "Breads, dips, little plates and bites to start.",
    items: [
      { name: "Village Bread & Butter", description: "" },
      { name: "Garlic Bread", description: "" },
      { name: "Garlic Bread & Cheese", description: "" },
      { name: "Greek Bruschetta", description: "Olives, tomato, feta & oregano." },
      { name: "Mixed Olives", description: "" },
      { name: "Tzatziki & Pita Bread", description: "" },
      { name: "Houmous Dip & Pita", description: "Chickpea dip." },
      { name: "Mixed Dip", description: "Tzatziki, hummus, cheese salad dip & pita." },
      { name: "Tirokafteri", description: "Spicy cheese salad dip." },
      { name: "Taramasalata", description: "Fish roe salad." },
      { name: "Saganaki Cheese", description: "Kaseri cheese in filo pastry with honey & sesame." },
      { name: "Feta Cheese", description: "Feta, olive oil & oregano." },
      { name: "Baked Feta", description: "Feta, tomato, peppers, tomato sauce & pita." },
      { name: "Stuffed Red Pepper with Feta", description: "" },
      { name: "Grilled Halloumi", description: "" },
      { name: "Soup of the Day", description: "" },
      { name: "Stuffed Tomato or Pepper", description: "Filled with rice." },
      { name: "Dolmadakia", description: "Stuffed vine leaves." },
      { name: "Onion Rings", description: "" },
      { name: "Cheese Pies", description: "" },
      { name: "Spinach Pie", description: "" },
      { name: "Spring Rolls (vegetarian)", description: "" },
      { name: "Vegetarian Balls", description: "Tomato & zucchini." },
      { name: "Garlic Mushrooms", description: "Pan-fried mushrooms in wine sauce." },
      { name: "Mushrooms & Cream", description: "Mushrooms in a fresh creamy sauce." },
      { name: "Breaded Fresh Mushrooms", description: "" },
      { name: "Meatballs in Tomato Sauce", description: "" },
      { name: "Grilled Village Sausage", description: "" },
      { name: "Sausage Yum Yum", description: "Oven-baked with peppers, onions & mushrooms in a spicy sauce, with pita." },
      { name: "Chicken Wings BBQ", description: "" },
      { name: "Greka", description: "Mushrooms with chicken & onions in creamy sauce, parmesan & pita." },
      { name: "Mussels Yum…Yum…", description: "Mussels & chilli pepper in tomato sauce with pita." },
      { name: "Shrimps in Spicy Sauce", description: "Shrimps & chilli in tomato sauce with pita." },
      { name: "Shrimps Saganaki", description: "Shrimps & feta in tomato sauce with pita." },
      { name: "Shrimps in Garlic & Wine", description: "" },
      { name: "Fried Calamari", description: "Squid." },
      { name: "Fried Sardines or Gavros", description: "" },
    ],
  },
  {
    name: "Salads",
    blurb: "Garden-fresh bowls, dressed simply.",
    items: [
      { name: "Greek Salad", description: "Tomato, cucumber, onion, pepper, feta, oregano & olives." },
      { name: "Bacon Salad", description: "Mixed leaves, bacon, cherry tomatoes, croutons, oil & lemon dressing." },
      { name: "Chef's Salad", description: "Lettuce, tomato, cucumber, cheese, ham, egg, cherry tomatoes." },
      { name: "Tuna Salad", description: "Lettuce, tomato, cucumber, onion, tuna & egg." },
      { name: "Salmon Salad", description: "Mixed leaves, cherry tomatoes, smoked salmon, orange, oil & lemon." },
      { name: "Caesar's Salad with Chicken", description: "Mixed leaves, cherry tomatoes, croutons, chicken, parmesan & Caesar dressing." },
      { name: "Mamamia Salad", description: "Mixed leaves, tomato, peppers, cucumber, chicken, bacon, avocado, parmesan, oil & lemon." },
      { name: "Seafood Salad", description: "Mixed leaves, tomato, cucumber, shrimp, mussels & octopus." },
    ],
  },
  {
    name: "Sharing Platters",
    blurb: "Built for the whole table.",
    items: [
      { name: "Mix Grill", description: "Lamb chops, belly pork, sausages, chicken fillet, beef burger, chips, salad & tzatziki." },
      { name: "Mama Mia Dish", description: "Chicken, pork & chicken-bacon souvlaki, lamb kebab and pork gyros — chips, tzatziki & pita." },
      { name: "Gyros Plate", description: "Pork & chicken gyros with chips, salad, tzatziki & pita." },
      { name: "Mix Grill + Mama Mia + ½ Wine (for 2)", description: "" },
      { name: "Greek Meze", description: "Beef kokkinisto, roast chicken, roast lamb, meatballs, gyro, cheese pies, pita & tzatziki." },
      { name: "Traditional Meze", description: "Moussaka, pastitsio, stuffed tomato, meatballs, gyros, roast potato & salad." },
    ],
  },
  {
    name: "Gyros & Souvlaki",
    blurb: "Char-grilled, straight from the spit. Served with chips, salad, tzatziki & pita.",
    items: [
      { name: "Gyros Plate", description: "" },
      { name: "Pork Souvlaki", description: "" },
      { name: "Mix Souvlaki", description: "Chicken, pork & lamb kebab." },
      { name: "Chicken Souvlaki", description: "" },
      { name: "Chicken & Bacon Souvlaki", description: "" },
      { name: "Halloumi Souvlaki", description: "" },
    ],
  },
  {
    name: "Traditional Greek Mains",
    blurb: "Slow-cooked, baked, simmered — the classics done properly.",
    items: [
      { name: "Moussaka", description: "Daily cooked." },
      { name: "Pastitsio", description: "" },
      { name: "Beef Kokkinisto", description: "Tender local beef casseroled with herbs & tomato." },
      { name: "Beef Yum…Yum…", description: "Beef with potatoes, mushrooms, onion, cream, tomato, feta & gouda." },
      { name: "Stifado", description: "Baby onions in tomato sauce — choice of lamb or beef." },
      { name: "Lamb to the Oven", description: "Slow-roasted lamb with potatoes, vegetables & gravy." },
      { name: "Lamb Zante", description: "Slow-roasted lamb with bacon, mushrooms, vegetables, potatoes, garlic & gravy." },
      { name: "Lamb Yum…Yum…", description: "Slow-roasted lamb with mushrooms, potatoes, salad, tomato, parmesan & feta in a ceramic pot." },
      { name: "Lamb Kleftiko", description: "Slow-roasted lamb with potatoes, peppers, mushrooms, gravy, parmesan & feta." },
      { name: "Lamb Shanks", description: "Slow-roasted with potatoes, vegetables & gravy." },
      { name: "Greek Roast Chicken", description: "With roasted potatoes, vegetables & gravy." },
      { name: "Chicken Hot Pot", description: "Onion, bacon, mushrooms, wine, creamy sauce, parmesan & melted cheese in a ceramic pot." },
      { name: "Stuffed Tomato & Pepper", description: "Rice-filled, with roasted potatoes & salad." },
      { name: "Meatballs Yum…Yum…", description: "Mushrooms in tomato sauce with parmesan & feta in a ceramic pot." },
      { name: "Spetsofai", description: "Sausage, hot tomato sauce, vegetables & feta." },
    ],
  },
  {
    name: "Chicken Mains",
    blurb: "Pan-fried, oven-baked, dressed in our own sauces.",
    items: [
      { name: "Mexican Chicken", description: "Peppers, onion, mushrooms, beans, tomato sauce, sweet chilli & sriracha." },
      { name: "Chicken Kiev", description: "Topped with garlic butter & creamy sauce." },
      { name: "Chicken with Honey & Orange", description: "" },
      { name: "Chicken Ala Crème", description: "Mushrooms in a fresh creamy sauce." },
    ],
  },
  {
    name: "Steaks & Grill",
    blurb: "From the charcoal grill. Pair with any sauce below.",
    items: [
      { name: "Beef Sirloin Steak", description: "" },
      { name: "Beef Fillet Steak", description: "" },
      { name: "Chicken Fillet", description: "" },
      { name: "Lamb Chops", description: "" },
      { name: "Pork Chop", description: "" },
      { name: "Bifteki", description: "Homemade with fresh mince." },
      { name: "Bacon Cheeseburger", description: "" },
      { name: "Pork Chop with Bacon & Mushrooms", description: "In wine sauce." },
      { name: "Pork Chop with Garlic & Mushrooms", description: "In wine sauce." },
      { name: "Pork Chop with Mustard & Honey", description: "" },
      { name: "Gammon Steak", description: "With pineapple & egg." },
      { name: "Belly Pork Chops", description: "" },
    ],
  },
  {
    name: "Choose Your Sauce",
    blurb: "Add to any steak or grill.",
    items: [
      { name: "Pepper Sauce", description: "Three peppers in madeira sauce." },
      { name: "Fresh Mushrooms Ala Crème", description: "Sautéed mushrooms in local white wine & cream." },
      { name: "Yum…Yum…", description: "Sun-dried tomato & halloumi in cream — beautiful with pork fillet or beef." },
      { name: "Blue Cheese", description: "Delicate creamy blue cheese." },
      { name: "Diana", description: "Creamy mustard & bacon." },
      { name: "Mustard & Honey", description: "" },
    ],
  },
  {
    name: "Pasta",
    blurb: "Choose pennes or spaghetti.",
    items: [
      { name: "Spaghetti Napolitana", description: "In tomato sauce." },
      { name: "Spaghetti Carbonara", description: "Bacon & mushrooms in a fresh creamy sauce." },
      { name: "Spaghetti Bolognese", description: "Fresh minced meat in rich tomato sauce." },
      { name: "Seafood Spaghetti", description: "King prawns, shrimps, mussels & onion in tomato sauce." },
      { name: "Spaghetti with Meatballs", description: "In rich tomato sauce." },
      { name: "Spaghetti with Fresh Vegetables", description: "Peppers, zucchini, carrots, cherry tomatoes & feta." },
      { name: "Pennes Arrabbiata", description: "Chilli & garlic in rich tomato sauce." },
      { name: "Pennes Chicken & Mushrooms", description: "Chicken, mushrooms & peppers in creamy sauce." },
      { name: "Pennes Bacon & Mushrooms", description: "Bacon & mushrooms in creamy tomato sauce with parmesan." },
      { name: "Pennes Chicken & Shrimps", description: "Chicken, shrimps, creamy sauce, tomato, vodka & parmesan." },
    ],
  },
  {
    name: "Risotto",
    blurb: "",
    items: [
      { name: "Risotto with Mushrooms & Truffle Oil", description: "" },
      { name: "Risotto with Chicken & Mushroom", description: "Chicken, mushrooms, tomato, cream & parmesan." },
      { name: "Vegetarian Risotto", description: "Peppers, onion, mushrooms, olives, cherry tomatoes, tomato, cream & parmesan." },
      { name: "Seafood Risotto", description: "Shrimps, mussels, tomato, cream & parmesan." },
    ],
  },
  {
    name: "Pizza",
    blurb: "Stone-baked.",
    items: [
      { name: "Special", description: "Gouda, ham, bacon, mushrooms, onion, peppers & tomato." },
      { name: "Margarita", description: "Gouda & tomato sauce." },
      { name: "Vegetarian", description: "Olives, mushrooms, onion, peppers & tomato." },
      { name: "Pepperoni", description: "" },
      { name: "4 Cheese", description: "Gouda, edam, feta & blue cheese." },
      { name: "Village", description: "Feta, gouda, olives, peppers, onion & tomato." },
      { name: "Mexican", description: "Onion, peppers, cheese, pepperoni & chilli." },
      { name: "Hawaii", description: "Gouda, ham, pineapple & tomato sauce." },
      { name: "Meat", description: "Gouda, sausage, ham, bacon & pepperoni." },
      { name: "Tuna", description: "Gouda, tuna, onion & tomato sauce." },
      { name: "Client's Pizza", description: "Build your own." },
    ],
  },
  {
    name: "Vegetarian",
    blurb: "Plant-forward plates.",
    items: [
      { name: "Vegetarian Meze", description: "Dolmadakia, broad beans, olives, feta, chips, pita & two dips." },
      { name: "Stuffed Tomato & Pepper", description: "Rice-filled, with roasted potatoes & salad." },
      { name: "Vegetarian Risotto", description: "Peppers, onion, mushrooms, olives, cherry tomatoes, tomato & creamy parmesan." },
      { name: "Risotto with Mushrooms & Truffle Oil", description: "" },
      { name: "Spaghetti with Fresh Vegetables", description: "Peppers, zucchini, carrots, cherry tomatoes & feta." },
      { name: "Vegetarian Pizza", description: "Olives, mushrooms, onion, peppers & tomato." },
      { name: "Village Pizza", description: "Feta, olives, peppers, onion & tomato." },
    ],
  },
  {
    name: "Fresh Fish & Seafood",
    blurb: "From local boats and our charcoal grill.",
    items: [
      { name: "Mix Seafood", description: "Swordfish, salmon, octopus, sardines, calamari, mussels, shrimps, salad & chips." },
      { name: "Sardines or Gavros", description: "" },
      { name: "Sea Bream", description: "" },
      { name: "Sea Bass", description: "" },
      { name: "Grilled Octopus", description: "" },
      { name: "Calamari", description: "Fried squid." },
      { name: "King Prawns Arrabbiata", description: "Chilli pepper & tomato sauce." },
      { name: "Grilled King Prawns", description: "" },
      { name: "Homemade Scampi", description: "" },
      { name: "Grilled Salmon Fillet", description: "" },
      { name: "Grilled Swordfish", description: "" },
      { name: "Swordfish Arrabbiata", description: "Chilli, tomato sauce, capers & olives." },
      { name: "Fresh Steamed Mussels", description: "With vegetables in wine & lemon sauce." },
      { name: "Fresh Mussels", description: "In spicy tomato sauce." },
      { name: "Fish to the Oven", description: "Fish fillet, mussels, shrimps, potatoes, cherry tomatoes, mushrooms, anchovies, chilli, onions & lemon." },
      { name: "Zakynthian Fish", description: "Fish fillet, potatoes, onion, capers, anchovies & tomato sauce." },
    ],
  },
  {
    name: "Children's Menu",
    blurb: "Small portions for little appetites.",
    items: [
      { name: "Any meal in kiddy portions", description: "Just ask." },
      { name: "Chicken Nuggets with Chips", description: "" },
      { name: "Chicken Fillet with Chips", description: "" },
      { name: "Meatballs with Chips", description: "" },
      { name: "Fish Fingers with Chips", description: "" },
      { name: "Spaghetti Bolognese", description: "" },
      { name: "Carbonara", description: "" },
      { name: "Spaghetti Napolitana", description: "" },
      { name: "Chicken Souvlaki", description: "" },
    ],
  },
  {
    name: "Soft Drinks & Juices",
    blurb: "",
    items: [
      { name: "Coca-Cola", description: "" },
      { name: "Fanta Orange · Lemon · Sprite", description: "" },
      { name: "Coca-Cola Light / Zero (250 ml)", description: "" },
      { name: "Soda (250 ml)", description: "" },
      { name: "Tonic (250 ml)", description: "" },
      { name: "Ice Tea (300 ml)", description: "" },
      { name: "Sparkling Water (250 ml)", description: "" },
      { name: "Large Water (1 L)", description: "" },
      { name: "Small Water (500 ml)", description: "" },
      { name: "Orange · Apple · Pineapple Juice", description: "" },
      { name: "Fresh Orange Juice", description: "" },
      { name: "Fruit Punch", description: "" },
    ],
  },
  {
    name: "Milkshakes",
    blurb: "",
    items: [
      { name: "Vanilla · Banana · Chocolate · Strawberry", description: "" },
    ],
  },
  {
    name: "Beers & Cider",
    blurb: "",
    items: [
      { name: "Strongbow", description: "" },
      { name: "Kopparberg Strawberry & Lime", description: "" },
      { name: "Magners", description: "" },
      { name: "Milokleftis — Greek Cider", description: "" },
      { name: "Corona", description: "" },
      { name: "Fix", description: "" },
      { name: "Alpha", description: "" },
      { name: "Mamos", description: "" },
      { name: "Bud", description: "" },
      { name: "Amstel (500 ml)", description: "" },
      { name: "Heineken (500 ml)", description: "" },
      { name: "Mythos (500 ml)", description: "" },
      { name: "Dark Beer (500 ml)", description: "" },
      { name: "Draft Beer — Large or Small", description: "" },
    ],
  },
  {
    name: "Wine",
    blurb: "House wine in white, rosé or red.",
    items: [
      { name: "By the Glass", description: "" },
      { name: "½ Litre Carafe", description: "" },
      { name: "1 Litre Carafe", description: "" },
      { name: "Sangria — Glass", description: "" },
      { name: "Sangria — ½ Litre", description: "" },
      { name: "Prosecco (small bottle)", description: "" },
      { name: "Moscato d'Asti (small bottle)", description: "Ask for the flavour." },
    ],
  },
  {
    name: "Spirits & Aperitifs",
    blurb: "",
    items: [
      { name: "Smirnoff Ice", description: "" },
      { name: "Bacardi Breezer", description: "" },
      { name: "Red Bull", description: "" },
      { name: "Ouzo", description: "" },
      { name: "Tsipouro", description: "" },
    ],
  },
  {
    name: "Cocktails",
    blurb: "Built behind the bar — or invent your own.",
    items: [
      { name: "Americano", description: "Campari, martini, soda." },
      { name: "Ice Ice Baby", description: "Vodka, southern comfort, grenadine, orange." },
      { name: "Francis", description: "Vodka, pineapple, orange, grenadine." },
      { name: "Blue Moon", description: "Gin, blue curaçao, lemon." },
      { name: "B52", description: "Kahlúa, Grand Marnier, Baileys." },
      { name: "Orgasm", description: "Vodka, Tia Maria, Baileys." },
      { name: "Never Again", description: "Vodka, Cointreau, lemon, grenadine." },
      { name: "Watermelon", description: "Southern comfort, amaretto, orange, grenadine." },
      { name: "Camelot Special", description: "Vodka, Malibu, peach schnapps, orange, grenadine." },
      { name: "Tsilivi Special", description: "Rum, amaretto, blue curaçao, lime, lemon & pineapple." },
      { name: "Bronx", description: "Dry & sweet martini, gin, orange." },
      { name: "Jelly Bean", description: "Vodka, ouzo, orange, grenadine." },
      { name: "Blue Dream", description: "Malibu, blue curaçao, pineapple." },
      { name: "Piña Colada", description: "Rum, Malibu, coconut, cream, pineapple." },
      { name: "Black Russian", description: "Vodka, Kahlúa, Coca-Cola." },
      { name: "Kamikaze", description: "Vodka, Cointreau, lemon, lime." },
      { name: "Blue Lagoon", description: "Blue curaçao, vodka, sprite." },
      { name: "Sex on the Beach", description: "Peach schnapps, vodka, orange, grenadine." },
      { name: "Zakynthos Shuffle", description: "Blue curaçao, vodka, peach schnapps, Malibu, orange." },
      { name: "Haylisa", description: "Blue curaçao, peach schnapps, vodka, orange." },
      { name: "Happy Days", description: "Grand Marnier, gin, orange, lemon." },
      { name: "Blue Lady", description: "Blue curaçao, gin, lemon." },
      { name: "Gin Fizz", description: "Gin, soda, lemon, sugar." },
      { name: "Negroni", description: "Sweet martini, gin, Campari, soda." },
      { name: "White Lady", description: "Cointreau, gin, lemon." },
      { name: "Pink Lady", description: "Grenadine, gin, lemon." },
      { name: "Orange Blossom", description: "Gin & orange." },
      { name: "Mojito", description: "Rum, sugar, soda, lime, mint." },
      { name: "Aperol Spritz", description: "Aperol, prosecco, soda." },
      { name: "Make Your Own", description: "Tell the bartender what you love." },
    ],
  },
  {
    name: "Non-Alcoholic Cocktails",
    blurb: "All the fun, none of the proof.",
    items: [
      { name: "Banana Colada", description: "Banana & pineapple juice, lime, cream." },
      { name: "Silvester", description: "Pineapple, apple & orange juice, grenadine." },
      { name: "Baby Piña Colada", description: "Tropical, lemon & orange juice, grenadine." },
      { name: "Pokemon", description: "Banana, pineapple & peach juice, blue curaçao." },
      { name: "Action Man", description: "Orange, banana & pineapple juice, blue curaçao." },
      { name: "Stavros", description: "Banana & orange juice, grenadine." },
      { name: "Tutti", description: "Blue curaçao, grenadine, cocktail juice." },
      { name: "Cinderella", description: "Pineapple, lemon & orange juice, grenadine." },
      { name: "Fruit Punch", description: "Lemon, grapefruit & orange juice, grenadine." },
    ],
  },
];
